module.exports = __webpack_public_path__ + "static/media/rhapsodynapster.ca90f3cc.jpg";